export const CLIENT_ID = {
    ARACRUZ:"1f951e4d-d692-4ff8-8236-429b1306b4a8",
    CACHOEIRO_ITAPEMIRIM:"ce744068-cc92-479f-bf9d-d88cf4238517",
    IBIRACI:"b5916ae4-347a-42a3-bda5-87b90ce4bcc7",
    SIMOES_FILHO:"19533831040781681800D2584C905F8A",
    PORTO_VELHO:"8051f762-e8f9-487c-b537-4b2ce582c5e9",
    PEDRO_CANARIO:"9DFDF7BDBB4580917C42BA8F7E4A5477",
    IPIAU:"e9bf088e-f06e-4618-815c-10d8122556a5",
    RIO_CLARO:"82a72051-c35b-4af3-abe0-93ce82e84b49",
    VITORIA_CONQUISTA:"bf1a05b0-3c4f-49a5-a2a0-acdc7092948f",
    NOVA_FRIBURGO:"008D9DCE8EF2707B45F47C2AD10B38E2",
    JOAO_MONLEVADE:"6866f81d-967e-4808-bb27-0dcf85594275",
    PETROLINA:"3d6adeff-3f83-4033-8b16-3f5d42fccd1a",
    JABOTICATUBAS:"B9861015B107786FEE47AE1AAE073260",
    TRES_CORACOES:"F58DEFAB039A9DB0F91C6B13F7C32A46",
    BRUMADINHO:"f1dc63e1-1459-4f45-bc23-322bc2c86eb5",
    DUAS_BARRAS:"38f4b9f6-5cbe-4adf-bc09-b62f041b9d33",
    BARREIRAS:"1AFF9FECC742DED8980F1F08BA1323B9",
    TESTE:"9A056422C49DEDE23B222C03E4436321"
};